import { featureTogglesDefault } from '../../config/featureToggles/envs/default';
import { ITdcsConfig } from '../../config/tdcs/tdcs.types';

// Default data for init of context
const tdcsDefault: ITdcsConfig = {
  type: 'client',
  version: 'failsafe-backup',
  analytics: {
    adobeEnabled: true,
  },
  logger: {
    level: 'info',
  },
  // Use what's baked into the app for Prod (defaults)
  featureToggles: featureTogglesDefault.toggles,
};

export default tdcsDefault;
